import { getEnfermedades as axiosGetEnfermedades } from "../axios/getEnfermedades";
import { useState, useEffect } from "react";

export interface Enfermedad {
  nombre: string;
  sinonimos?: string[] | null;
}

export interface SearchbarOption {
  value: string;
  label: string;
  sinonimos: string[];
}

export const useEnfermedad = () => {
  const [searchableEnfermedades, setSearchableEnfermedades] = useState<SearchbarOption[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getEnfermedades = async () => {
    setIsLoading(true);
    try {
      const enfermedades: Enfermedad[] = await axiosGetEnfermedades();

      const search_enfermedades: SearchbarOption[] = enfermedades.map(({ nombre, sinonimos }) => {
        // Si sinonimos es null o undefined, asignamos un array vacío
        const validSinonimos = sinonimos
          ? sinonimos.map(sinonimo => sinonimo.trim())
          : [];

        return {
          value: nombre,
          label: nombre,
          sinonimos: validSinonimos
        };
      });

      setSearchableEnfermedades(search_enfermedades);
    } catch (error) {
      console.error("Error fetching enfermedades:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getEnfermedades();
  }, []);

  return {
    searchableEnfermedades,
    isLoading
  };
};
